import { ActionTree } from 'vuex';
import { LlmState } from './types';
import { RootState } from '../../types';
import { defaultBackendLlm, AssistantAnswer } from '@/shared/backend/llm';
import { Logger } from 'fsts';
import moduleUtils from '../moduleUtils';
import { AxiosResponse } from 'axios';

const logger = new Logger('actions.llm');

export const actions: ActionTree<LlmState, RootState> = {
  test(
    { commit },
    payload: { question: string; role: string; project: string; model: string }
  ) {
    commit('setIsLoading', true);
    commit('setAnswer', '');
    return defaultBackendLlm
      .test(payload.question, payload.role, payload.project, payload.model)
      .then((response: AxiosResponse<AssistantAnswer>) => {
        commit('setAnswer', response.data.answer);
        return response.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  ask(
    { commit },
    payload: { question: string; role: string; project: string; model: string }
  ) {
    commit('setIsLoading', true);
    commit('setAnswer', '');
    return defaultBackendLlm
      .ask(payload.question, payload.role, payload.project, payload.model)
      .then((response: AxiosResponse<AssistantAnswer>) => {
        commit('setAnswer', response.data.answer);
        return response.data;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
      })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  async streamChat(
    { commit, state },
    payload: { question: string; role: string; project: string; signal?: AbortSignal }
  ) {
    commit('setIsLoading', true);
    commit('setAnswer', '');
    try {
      await defaultBackendLlm.streamChat(
        payload.question,
        payload.role,
        payload.project,
        (chunk: string) => {
          commit('setAnswer', state.answer + chunk);
        },
        payload.signal
      );
    } catch (e: any) {
      if (e?.name !== 'AbortError') {
        moduleUtils.error('error', commit, e, logger);
      }
    } finally {
      commit('setIsLoading', false);
    }
  },
};
